import { Id } from '@shared/types/id';

export class EquipmentCategory {
  constructor(
    readonly id: Id,
    readonly name: string,
    readonly createdAt: Date
  ) {}
}
